import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsItem } from '@zero/shared/util-models';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InstrumentNewsService {
  private readonly endpoint = environment.apihost + environment.instrumentNews;

  constructor(private http: HttpClient) {}

  public loadNews(isin: string) {
    return this.http.get<NewsItem[]>(`${this.endpoint}/${isin}`);
  }
}
